import {
  MENU_COLLAPSED,
  OPENED_GROUPS,
} from './constants';

import type {
  LayoutState,
} from './types';

export const parseLayoutFromLocalStorage = (): LayoutState => {
  let menuCollapsed: boolean | null;
  try {
    const menuCollapsedRaw = localStorage[MENU_COLLAPSED] as string | undefined;
    const menuCollapsedParsed = menuCollapsedRaw
      ? JSON.parse(menuCollapsedRaw) as unknown
      : undefined;

    if (typeof menuCollapsedParsed === 'boolean') {
      menuCollapsed = menuCollapsedParsed;
    } else {
      menuCollapsed = null;
    }
  } catch (e) {
    menuCollapsed = null;
  }

  let openedGroups: Record<string, boolean> | null;
  try {
    const openedGroupsRaw = localStorage[OPENED_GROUPS] as string | undefined;
    const openedGroupsParsed = openedGroupsRaw
      ? JSON.parse(openedGroupsRaw) as unknown
      : undefined;

    if (typeof openedGroupsParsed === 'object') {
      openedGroups = openedGroupsParsed as Record<string, boolean>;
    } else {
      openedGroups = null;
    }
  } catch (e) {
    openedGroups = null;
  }

  return {
    menuCollapsed,
    openedGroups,
  };
};
